<template>

  <fold-button v-if="user_schools.length" title="language.login_existing_school">


  
  <div class="container" :class="{'logged-in':school.active }" v-for="(school, index) in sort_on_active" :key="index">
    
    <my-school :school="school" :index="index+updateKey" @update="update()"></my-school>

    <div class="toolbar">
      <ui-icon v-on:click.native="removeSchool(school)" class="icon" v-bind:style="{fontSize:'1',margin:'0'}" backgroundColor="#FF0000" color="#FFFFFF" icon="times"></ui-icon>
    </div>
   
  </div>


  
 </fold-button>
</template>

<script>
import { mapState } from 'vuex';
import UiIcon from '../components/UiIcon.vue';
import FoldButton from '../components/buttons/FoldButton.vue';
import MySchool from '../components/MySchool.vue';

export default {
  name: 'my-schools',
  data(){
    return {
      updateKey:0,
    }
  },
  computed:{
  ...mapState([
    'user_schools'
    ]),
    sort_on_active(){
       // eslint-disable-next-line
      let sorted = [...this.user_schools]

      return sorted.sort((a, b) => (a.active < b.active) ? 1 : -1)
    },
  },
  components:{
    UiIcon,
    FoldButton,
    MySchool,
  },
  methods:{
    removeSchool(school){
      this.$store.dispatch("removeSchool",{school})
    },
    update(){
      this.updateKey=new Date().getTime();
     
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  padding:10px;
  border:1px solid #EEEEEE;
  border-radius:4px;
  margin-bottom:10px;
  position:relative;
}

#user-name{
  margin-bottom:10px;
}
.icon{
  cursor:pointer;
  margin-left:5px!important;
}
.toolbar{
  position:absolute;
  top:10px;
  right:10px;
  display:inline-flex;
}
.logged-in{
  border:1px solid #00DD00;
}
</style>
